<template>
  <div class="chart10">
    <div id="Chart10" style="width: 700px; height: 120px"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    myEcharts10() {
      var myChart10 = this.$echarts.init(document.getElementById("Chart10"));
      //配置图表
      var option10 = {
        grid: {
          containLabel: true,
          left: 0,
          right: -10,
          bottom: 0,
          top: 10,
        },
        xAxis: {
          type: "value",
          show: false,
        },
        yAxis: {
          axisTick: {
            show: false,
            lineStyle: {
              width: "122",
            },
          },
          axisLine: {
            show: false,
            lineStyle: {
              // color: "#ededed",
            },
          },

          data: ["分红", "募资"],
          axisLabel: {
            formatter: function (value) {
              return value;
            },
          },
        },
        series: [
          {
            name: "格力电器",
            type: "bar",
            barGap: "-100%",

            data: [
              {
                value: 896.2,
                itemStyle: {
                  color: "#539cff",
                },
              },
              {
                value: 152.8,
                itemStyle: {
                  color: "rgba(252,173,42,1)",
                },
              },
            ],
            barWidth: 24,
            z: 300,
          },
          {
            name: "格力电器",
            type: "bar",
            barGap: "-100%",
            data: [
              {
                value: 896.2,
                itemStyle: {
                  color: "#539cff",
                },
              },
              {
                value: 352.8,
                itemStyle: {
                  color: "rgba(252,173,42,.6)",
                },
              },
            ],
            barWidth: 24,
            z: 200,
          },
          {
            name: "格力电器",
            type: "bar",
            barGap: "-100%",
            label: {
              formatter: "{c}亿",
              show: true,
              position: "right",
            },
            data: [
              {
                value: 896.2,
                itemStyle: {
                  color: "#539cff",
                },
              },
              {
                value: 552.8,
                itemStyle: {
                  color: "rgba(252,173,42,.4)",
                },
              },
            ],
            barWidth: 24,
            z: 100,
          },
        ],
      };
      myChart10.setOption(option10);
    },
  },
  mounted() {
    this.myEcharts10();
  },
};
</script>

<style scoped>
</style>